export default __webpack_public_path__ + "static/media/dropdownArrow.99e4182c.svg";